export default __webpack_public_path__ + "static/media/Quiken_Presicion-12.1ed77d8a.svg";